import { render, staticRenderFns } from "./ArticlesOnSales.vue?vue&type=template&id=bee1a72e&scoped=true"
import script from "./ArticlesOnSales.vue?vue&type=script&lang=js"
export * from "./ArticlesOnSales.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOnSales.vue?vue&type=style&index=0&id=bee1a72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1a72e",
  null
  
)

export default component.exports